import React from "react";
import { MapsButton } from "./MapsButton";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

function formatDuration(minutes) {
  if (!minutes) return null;
  if (minutes < 60) return `~${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `~${h}h${m.toString().padStart(2, "0")}` : `~${h}h`;
}

export function ActivityRow({ activity, isLast }) {
  const { icone, heure_debut, titre, lieu, duree_minutes, prix_euros, note, google_maps_query } =
    activity;

  const durationStr = formatDuration(duree_minutes);
  const showPrice = prix_euros !== -1 && prix_euros !== undefined && prix_euros !== null;
  const isFree = prix_euros === 0;

  return (
    <div className="py-3" data-testid="activity-row">
      <div className="flex items-start gap-3">
        {/* Emoji icon */}
        <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#F1EBE1] flex items-center justify-center text-lg mt-0.5">
          {icone}
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Line 1: time + title + maps */}
          <div className="flex items-center gap-2 justify-between">
            <div className="flex items-center gap-2 min-w-0 flex-1">
              <span
                className="text-sm font-semibold text-[#C17F59] flex-shrink-0"
                style={LORA}
              >
                {heure_debut}
              </span>
              <span
                className="text-[#2B2623] truncate"
                style={{ ...LORA, fontSize: "0.875rem" }}
              >
                {titre}
              </span>
            </div>
            {google_maps_query && <MapsButton query={google_maps_query} />}
          </div>

          {/* Line 2: lieu · durée · prix */}
          <div className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 mt-0.5">
            {lieu && (
              <span className="text-xs text-[#9A8F86]" style={LORA}>
                📍 {lieu}
              </span>
            )}
            {durationStr && (
              <>
                <span className="text-[#DCD4C6] text-xs select-none">·</span>
                <span className="text-xs text-[#9A8F86]" style={LORA}>
                  {durationStr}
                </span>
              </>
            )}
            {showPrice && (
              <>
                <span className="text-[#DCD4C6] text-xs select-none">·</span>
                {isFree ? (
                  <span
                    className="text-xs bg-emerald-50 text-emerald-700 border border-emerald-200 px-1.5 py-0.5 rounded-sm"
                    style={LORA}
                  >
                    Gratuit
                  </span>
                ) : (
                  <span className="text-xs text-[#9A8F86]" style={LORA}>
                    ~{prix_euros}€/pers
                  </span>
                )}
              </>
            )}
          </div>

          {/* Line 3: note */}
          {note && (
            <p className="text-xs text-[#9A8F86] italic mt-0.5" style={LORA}>
              — {note}
            </p>
          )}
        </div>
      </div>

      {!isLast && <div className="mt-3 border-t border-[#EDE8E0]" />}
    </div>
  );
}
